module.exports = "/dist/240a84447b78da0920fcb07e378f2c5f.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-400.woff2
// module id = 121
// module chunks = 0